<form [formGroup]="dynamicForm" class="flex flex-wrap">
    <div *ngFor="let field of fieldsConfigData" class="col-6 mb-1 fields-container mx-auto px-4 mx-auto px-4">
        <ng-container [ngSwitch]="field.fieldTypeId">
            <!-- Text Field -->
            <div *ngSwitchCase="'TEXTBOX'" class="col-12">
                <label class="field-label">{{ field.fieldName }}</label>
                <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary w-100" [formControlName]="field.fieldName"
                    [value]="field?.selectedValue" />
            </div>
            <!-- Radio Button -->
            <div *ngSwitchCase="'RADIO_BUTTON'" class="col-12">
                <label class="field-label">{{ field.fieldName }}</label>
                <div *ngFor="let option of field.values; let j = index" class="field-control">
                    <input type="radio" [formControlName]="field.fieldName" [id]="field.fieldName + '-' + j" [value]="option" />
                    <label class="form-check-label ml-2" [for]="field.fieldName + '-' + j">
                        {{ option }}
                    </label>
                </div>
            </div>
            <!-- Checkbox -->
            <div *ngSwitchCase="'CHECKBOX'" class="col-12">
                <label class="field-label">{{ field.fieldName }}</label>
                <!-- Multiple options: maintain an array of selected values in the control -->
                <ng-container *ngIf="field.values?.length > 1; else singleCheckboxTpl">
                    <div *ngFor="let option of field.values; let j = index" class="field-control">
                        <input class="form-check-input" type="checkbox"
                            [id]="field.fieldName + '-' + j"
                            [checked]="(dynamicForm.get(field.fieldName)?.value || []).includes(option)"
                            (change)="onCheckboxChange($event, field.fieldName, option)">
                        <label class="form-check-label ml-2" [for]="field.fieldName + '-' + j">
                            {{ option }}
                        </label>
                    </div>
                </ng-container>
                <!-- Single option: treat as boolean control -->
                <ng-template #singleCheckboxTpl>
                    <div class="field-control">
                        <input class="form-check-input" type="checkbox" [id]="field.fieldName"
                            [formControlName]="field.fieldName">
                        <label class="form-check-label ml-2" [for]="field.fieldName">
                            {{ field.values?.[0] || field.fieldName }}
                        </label>
                    </div>
                </ng-template>
            </div>
            <!-- Select Dropdown -->
            <div *ngSwitchCase="'SELECT'" class="col-12">
                <label class="field-label">{{ field.fieldName }}</label>
                <select class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary w-100" [formControlName]="field.fieldName">
                    <option *ngFor="let option of field.values" [value]="option">{{ option }}</option>
                </select>
            </div>
            <!-- Add more field types as needed -->
            <div *ngSwitchDefault class="col-12">
                    <label class="field-label">{{ field.fieldName }}</label>
                    <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary w-100" [formControlName]="field.fieldName" />
                </div>
        </ng-container>
    </div>
</form>